import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import jwt_decode from "jwt-decode";

import env from 'lib/env';

import signIn from 'action-creators/account/sign-in';

class GoogleSignInButton extends React.Component {
  constructor(props) {
    super(props);

    this.buttonRef = React.createRef();
    this.onGoogleSignIn = this.onGoogleSignIn.bind(this);
    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    const { GOOGLE_OAUTH_ID } = env();
    try {
      google.accounts.id.initialize({
        client_id: GOOGLE_OAUTH_ID,
        callback: this.onGoogleSignIn,
        auto_select: true,
      });
      this.renderGoogleSignIn();
    } catch (e) {
      this.setState({ error: 'There was a problem contacting Google. Please try again later.' });
    }
  }

  renderGoogleSignIn() {
    google.accounts.id.renderButton(this.buttonRef.current, {});
  }

  onGoogleSignIn(credentialResponse) {
    const decodedResponse = jwt_decode(credentialResponse.credential);
    const { email, given_name: givenName, family_name: familyName } = decodedResponse;

    this.props.signIn({
      credentialType: 'google',
      email,
      first_name: givenName,
      last_name: familyName,
      google_id_token: credentialResponse.credential,
      redirectURI: this.props.redirectURI,
      marketingAllowed: this.props.marketingAllowed,
    });
  }

  render() {
    return <div
      ref={this.buttonRef}
    >{this.state.error}</div>;
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({ signIn }, dispatch)
);

export default connect(null, mapDispatchToProps)(GoogleSignInButton);
